import { useCallback } from "react";
import { Link, useParams } from "react-router";
import { routes } from "../../app/routes";
import { useResource } from "../../platform/async/useResource";
import { formatDate } from "../../platform/time/format-date";
import { PagedReader } from "../../platform/ui/PagedReader";
import { PageShell } from "../../platform/ui/PageShell";
import { StateMessage } from "../../platform/ui/StateMessage";
import { fetchPost } from "./blog-api";
import { PostBody } from "./PostBody";
import "./blog.css";

export function PostPage() {
  const { slug = "" } = useParams();
  const post = useResource(useCallback((signal) => fetchPost(slug, signal), [slug]));

  if (post.status === "loading") {
    return (
      <PageShell title="Orla's Blog">
        <StateMessage tone="loading" title="Fetching the post" />
      </PageShell>
    );
  }
  if (post.status === "failed") {
    const missing = post.error.failure === "not_found";
    return (
      <PageShell title={missing ? "Post not found" : "Orla's Blog"}>
        <StateMessage
          tone="error"
          title={missing ? "There is no post at this address" : "The post could not be loaded"}
          {...(missing ? {} : { action: { label: "Try again", onSelect: post.retry } })}
        >
          {missing ? "It may have been unpublished or moved." : post.error.message}
        </StateMessage>
        <p>
          <Link to={routes.blog()}>Back to the blog</Link>
        </p>
      </PageShell>
    );
  }
  return (
    <PageShell title={post.data.title} lead={post.data.summary} layout="viewport">
      <PagedReader label={post.data.title}>
        <article>
          <PostBody markdown={post.data.bodyMd} />
        </article>
      </PagedReader>
      <p className="post-back">
        {post.data.publishedAt ? (
          <time className="post-meta" dateTime={post.data.publishedAt}>
            {formatDate(post.data.publishedAt)}
          </time>
        ) : null}
        <Link to={routes.blog()}>All posts</Link>
      </p>
    </PageShell>
  );
}
